var giphy_viewer_default = {
  "giphyWrapper": "_4GiLO",
  "giphy_player": "_3Qv8o",
  "playIcon": "SGTfH",
  "gifRatio": "-aU3j"
};
export {
  giphy_viewer_default as default
};
//# sourceMappingURL=giphy-viewer-scss.js.map
